import FallbackVisualization from './FallbackVisualization'

export default FallbackVisualization
